import React from "react";
import { Box } from "@mui/material";

export const Logo = ({ logoURL }) => {
  return (
    <Box className="header-logo-container">
      <img
        src={!!logoURL ? logoURL : "/img/logo.svg"}
        alt="Org logo"
      />
    </Box>
  );
};
